import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { UploadedImage } from '@/pages/ImageToolsHub';

interface ImageLibraryProps {
  images: UploadedImage[];
  setImages: React.Dispatch<React.SetStateAction<UploadedImage[]>>;
}

export const ImageLibrary: React.FC<ImageLibraryProps> = ({ images, setImages }) => {
  const toggleSelect = (id: string) => {
    setImages(prev =>
      prev.map(img => img.id === id ? { ...img, selected: !img.selected } : img)
    );
  };

  const selectedImages = images.filter(img => img.selected);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Image Library</CardTitle>
        <CardDescription>
          Select images to apply tools. {selectedImages.length} of {images.length} selected.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {images.map((image) => (
            <div
              key={image.id}
              className={`relative group rounded-lg overflow-hidden border-2 cursor-pointer transition-all ${
                image.selected ? 'border-primary ring-2 ring-primary/20' : 'border-border'
              }`}
              onClick={() => toggleSelect(image.id)}
            >
              <img
                src={image.preview}
                alt={image.name}
                className="w-full aspect-square object-cover"
              />
              {image.selected && (
                <div className="absolute inset-0 bg-primary/20 flex items-center justify-center">
                  <Badge variant="default">Selected</Badge>
                </div>
              )}
              <div className="absolute bottom-0 left-0 right-0 bg-black/60 p-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <p className="text-xs text-white truncate">{image.name}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
